export const stepOneData = [
  {
    stepOneHeading: "1. What is a balance transfer? ",
    paraOne:
      "A balance transfer involves moving your outstanding debt from a high-interest credit card or loan to another lender offering a lower interest rate or more favorable terms. This approach reduces your EMI burden and interest payments, helping you pay off your debt faster.",

    paraTwo:
      "For instance, if you have a credit card charging 36% interest annually, you could transfer the balance to a card with a 0% introductory APR or a personal loan offering a lower rate.",
    minTip:
      " In India, balance transfers are available for credit cards, personal loans, car loans, and even home loans. MinEMI helps you compare the best options suited to your financial goals.",
  },
];

export const stepTwoData = [
  {
    stepTwoHeading: "2.Who Should Do a Balance Transfer? ",
    subhead:
      "A balance transfer is ideal for individuals facing one of the following situations:",
    infoList: [
      {
        info: "Struggling with High-Interest Debt:",
        description:
          "If most of your monthly payment goes toward interest rather than reducing the principal, a balance transfer can help you save significantly.",
      },
      {
        info: "Need to Consolidate Debts:",
        description:
          " If you have multiple debts across credit cards or loans, transferring them into one manageable account can streamline your repayments.",
      },
      {
        info: "Mid-Tenure of Your Loan:",
        description:
          " Transferring a loan during its early or middle tenure can result in maximum interest savings. MinEMI can calculate the ideal time for a transfer.",
      },
      {
        info: "Improved Credit Score:",
        description:
          "If your credit score has improved recently, you might qualify for better terms, making a balance transfer worthwhile.",
      },
      {
        info: " Temporary Financial Challenges:",
        description:
          " If you’re facing financial hardship, a balance transfer can provide breathing room by reducing your interest burden temporarily.",
      },
    ],
    minTip:
      "Use MinEMI’s Balance Transfer Calculator to find out how much you can save by transferring your existing debts.",
  },
];

export const stepThreeData = [
  {
    stepThreeHeading: "3. Who Can Do a Balance Transfer in India? ",
    infoList: [
      {
        info: " Eligibility Criteria:",
        description:
          "Balance transfer offers are typically available to borrowers with a good credit score (650+). Lenders also consider your income and existing debt before approving a transfer.",
      },
      {
        info: " Transfer Limits:",
        description:
          " The new lender may not approve the entire outstanding amount for transfer. The limit depends on your credit profile and the lender’s policies.",
      },
      {
        info: "Restrictions:",
        description:
          "Transfers are not allowed between loans or cards from the same bank. For example, you cannot transfer a debt from one SBI card to another SBI card.",
      },
    ],
    minTip:
      " If your credit score is below 650, MinEMI can help you identify lenders who cater to your profile.",
  },
];

export const stepFourData = [
  {
    stepFourHeading: "4.How to Do a Balance Transfer in India ",

    infoList: [
      {
        info: "Compare Options with MinEMI:",
        description:
          "Use MinEMI’s platform to explore balance transfer offers from various lenders.",
      },
      {
        info: "Check the Fees:",
        description:
          "Understand the processing fees, transfer charges, and prepayment penalties involved. MinEMI lists these costs upfront for transparency. ",
      },
      {
        info: "Apply for the Transfer:",
        description:
          "Submit the necessary documents, including your existing loan statement, ID proof, and income details.",
      },
      {
        info: " Obtain NOC:",
        description:
          "Get a No Objection Certificate (NOC) from your current lender and ensure all outstanding dues are cleared during the transfer.",
      },
      {
        info: " Pay Down Your Balance:",
        description:
          "Once the balance is transferred, focus on repaying the new loan or credit card balance to maximize savings.",
      },
    ],
  },
];

export const stepFiveData = [
  {
    stepFiveHeading: "5. How Much Can You Save with a Balance Transfer? ",
    paraOne: "Your savings depend on several factors:",
    balanceList: [
      {
        info: " Existing Debt Amount:  ",
        description: "Higher debt means higher potential savings.",
      },
      {
        info: " Current Interest Rate: ",
        description:
          "Transferring from a high-interest loan or card can lead to significant savings.",
      },
      {
        info: "Balance Transfer Fee: ",
        description:
          "In India, transfer fees typically range from 1% to 3% of the outstanding amount.",
      },
      {
        info: "Repayment Duration: ",
        description:
          "The longer your repayment period, the more interest savings you can achieve.",
      },
    ],

    paraTwo:
      "Even so, our balance transfer calculator can give you a general sense of what you could pay if you didn't do the transfer, compared with what the transfer would cost. ",
  },
];

export const stepSixData = [
  {
    stepSixHeading: "6. When Not to Do a Balance Transfer",

    infoList: [
      {
        info: " Near Loan Completion:",
        description:
          "If most of the interest has already been paid, transferring won’t save much.",
      },
      {
        info: " High Processing Fees:",
        description:
          "If the fees outweigh potential savings, a balance transfer may not be cost-effective.",
      },
      {
        info: "Poor Credit Profile:",
        description:
          "A low credit score may result in higher interest rates on the new loan.",
      },
    ],
  },
];

export const stepSevenData = [
  {
    stepSevenHeading:
      "7.How to Choose the Best Balance Transfer Option in India",
    infoList: [
      {
        info: " Compare Lenders:",
        description:
          "Look for lenders offering lower interest rates and minimal fees. MinEMI simplifies this process.",
      },
      {
        info: "  Consider Tenure Flexibility:",
        description:
          "Ensure the new loan or card offers a repayment period that aligns with your goals.",
      },
      {
        info: "Check for Additional Benefits:",
        description:
          "Some lenders offer top-up loans or additional credit limits during balance transfers.",
      },
    ],

    paraOne: "How MinEMI Simplifies Balance Transfers ",
    paraTwo:
      "MinEMI is your one-stop solution for balance transfers in India. From identifying the best lenders to calculating savings and guiding you through the process, MinEMI ensures a seamless experience. With expert insights and real-time tools, MinEMI helps you make smarter financial decisions.",
    paraThree: "Start Your Balance Transfer Journey with MinEMI Today!",
  },
];
